import React from 'react';

const Footer = () => {
	return (
		<footer>
			Visas tiesības aizsargātas &copy; Rīgas Tālmācības vidusskola
		</footer>
	);
};

export default Footer;